import sanitize from 'sanitize-html';
import linkifyHtml from 'linkify-html';

import nl2br from '../nl2br';
import { sanitizeRegular } from '../../constants/sanitizeConfigs';
import { ITemplateTitles, templateRender } from '../templates';

export default (text: string, attributeToRemove?: string) => {
  if (attributeToRemove && text) {
    const re = new RegExp(`${attributeToRemove}="[a-zA-Z0-9:;.s()-,]*"`, 'gi');

    return {
      __html: text.replace(re, ''),
    };
  }

  return {
    __html: linkifyHtml(nl2br(sanitize(text, sanitizeRegular)), {
      target: '_blank',
      rel: 'nofollow',
      ignoreTags: ['code'],
    }),
  };
};

export const removeHTMLTags = (message: string) => {
  return message && message.replace(/<\/?[a-zA-Z][\w-]*\b[^>]*>/g, ' ');
};

export const sanitizeFAQ = (text: string, titles: ITemplateTitles) => {
  const htmlTagsRegex = /<\/?[a-z][\s\S]*>/i;
  let html = text;

  if (!text.match(htmlTagsRegex)) {
    html = nl2br(text);
  }

  html = sanitize(linkifyHtml(templateRender(html, titles)), sanitizeRegular);
  const htmlFixedLinks = html.replace(/(@)<a[^>]*>([^<]*)<\/a>/g, '$1$2');

  return { __html: htmlFixedLinks };
};

export const sanitizeReleaseNote = (text: string, titles: ITemplateTitles) => {
  return { __html: sanitize(templateRender(text, titles), sanitizeRegular) };
};

